import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Button,
  ButtonPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/buttons.scss';

export type NcButtonT = React.FC<ButtonPropsT>;

export const NcButton: NcButtonT = ({
  children,
  className,
  ...props
}) => {
  const classNames = mergeClassNameStrings('nc-button', className);

  return (
    <Button className={classNames} {...props}>
      {children}
    </Button>
  );
};
